<div class="sticky-tab-panel w-full">
  <div [class.selected]="selectedSection === sectionId">
    <button class="btn" [class.selected-btn]="selectedSection !== sectionId">
      {{ sectionName }}
    </button>
    <div
      style="
        display: flex;
        align-items: center;
        height: 0px;
        padding-left: 5px;
        padding-right: 5px;
      "
    >
      <mat-progress-bar
        class="!custom-progress-bar"
        [class.selected-progress-bar]="selectedSection === sectionId"
        [class.default-progress-bar]="selectedSection !== sectionId"
        mode="determinate"
        value="{{ progress }}"
      ></mat-progress-bar>
    </div>
    <p
      class="percentage !mt-[5px]"
      [class.selected-percentage]="selectedSection !== sectionId"
    >
      {{ progress | number : "1.0-0" }}% completed
    </p>
  </div>
</div>
